import { LocalStorageSidebarKey } from '../../utils/constants';
import { getStorageObject, setStorageObject } from '../../utils/global';
import { SET_SIDEBAR_EFFECTIVE_EXPANDED, SET_SIDEBAR_EXPANDED } from './sidebarTypes';

const getInitialExpandedState = () => {
  const localStorageExpanded = getStorageObject(LocalStorageSidebarKey);
  return localStorageExpanded === null ? true : localStorageExpanded.isExpanded;
};

const initialState = {
  isExpanded: getInitialExpandedState(),
  isEffectiveExpanded: getInitialExpandedState(),
};

const sidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SIDEBAR_EXPANDED: {
      setStorageObject(LocalStorageSidebarKey, { isExpanded: action.payload });
      window.dispatchEvent(
        new CustomEvent('sidebarStateChange', {
          detail: { isExpanded: action.payload },
        })
      );
      return {
        ...state,
        isExpanded: action.payload,
      };
    }
    case SET_SIDEBAR_EFFECTIVE_EXPANDED:
      return {
        ...state,
        isEffectiveExpanded: action.payload,
      };
    default:
      return state;
  }
};

export default sidebarReducer;
